// Profile.js
import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Profile = () => {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: ""
  });
  const [isEditing, setIsEditing] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || "",
        email: user.email || ""
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        "https://api.todaytalks.in/api/auth/profile",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      
      setMessage("Profile updated successfully!");
      setIsEditing(false);
      
      // Update user data in context and local storage
      const updatedUser = { ...user, ...formData };
      setUser(updatedUser);
      localStorage.setItem("user", JSON.stringify(updatedUser));
      
    } catch (error) {
      console.error("Failed to update profile", error);
      setMessage("Error updating profile: " + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: user.name || "",
      email: user.email || ""
    });
    setIsEditing(false);
    setMessage("");
  };

  if (!user) {
    return (
      <div className="profile-container">
        <h1>Profile</h1>
        <p>Please log in to view your profile.</p>
        <button onClick={() => navigate("/login")}>Login</button>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <h1>Your Profile</h1>
      
      {message && <div className={`message ${message.includes("Error") ? "error" : "success"}`}>{message}</div>}
      
      <form onSubmit={handleSubmit} className="profile-form">
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            disabled={!isEditing || loading}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            disabled={!isEditing || loading}
            required
          />
        </div>
        
        {isEditing ? (
          <div className="form-actions">
            <button type="submit" className="save-btn" disabled={loading}>
              {loading ? "Saving..." : "Save Changes"}
            </button>
            <button type="button" onClick={handleCancel} className="cancel-btn" disabled={loading}>
              Cancel
            </button>
          </div>
        ) : (
          <button 
            type="button" 
            onClick={() => setIsEditing(true)} 
            className="edit-btn"
          >
            Edit Profile
          </button>
        )}
      </form>
    </div>
  );
};

export default Profile;